import { ArrowRight } from "@phosphor-icons/react"
import { Icon, type IconProps } from "@tokenterminal/core/ui/icon/Icon"
import Link from "next/link"
import { popoverDropdownLinkCss } from "./Header"

type SublinkItemProps = {
  href: string
  label: string
  showArrow?: boolean
  icon?: IconProps["as"]
}

export const SublinkItem = ({
  href,
  label,
  showArrow = true,
  icon,
}: SublinkItemProps) => {
  return (
    <Link href={href} className={popoverDropdownLinkCss}>
      {icon && (
        <Icon
          as={icon}
          weight="bold"
          width="16"
          className="text-fg-secondary/70"
        />
      )}
      <div className="flex gap-2 items-center justify-between w-full">
        {label}
        {showArrow && (
          <Icon
            as={ArrowRight}
            width="16"
            className="text-fg-secondary opacity-0 group-hover:opacity-100 transition-opacity duration-200"
          />
        )}
      </div>
    </Link>
  )
}
